import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

/**
 * Owl Slide Show
 */
@Component
class Props extends Mixins() {
    /**
     * The number of items you want to see on the screen.
     */
    @Prop({ type: Number, default: 3 }) items!: number;

    /**
     * Margin-right (px) on item.
     */
    @Prop({ type: Number, default: 3 }) margin!: number;

    /**
     * Infinity loop. Duplicate last and first items to get loop illusion.
     */
    @Prop({ type: Boolean, default: false }) loop!: boolean;

    /**
     * Center item. Works well with even an odd number of items.
     */
    @Prop({ type: Boolean, default: false }) center!: boolean;

    /**
     * Show next/prev buttons.
     */
    @Prop({ type: Boolean, default: false }) nav!: boolean;

    /**
     * Autoplay.
     */
    @Prop({ type: Boolean, default: false }) autoplay!: boolean;

    /**
     * Autoplay speed.
     */
    @Prop({ default: false }) autoplaySpeed!: boolean|number;

    /**
     * Go backwards when the boundary has reached.
     */
    @Prop({ type: Boolean, default: true }) rewind!: boolean;

    /**
     * Mouse drag enabled.
     */
    @Prop({ type: Boolean, default: true }) mouseDrag!: boolean;

    /**
     * Touch drag enabled.
     */
    @Prop({ type: Boolean, default: true }) touchDrag!: boolean;

    /**
     * Stage pull to edge.
     */
    @Prop({ type: Boolean, default: true }) pullDrag!: boolean;

    /**
     * Item pull to edge.
     */
    @Prop({ type: Boolean, default: false }) freeDrag!: boolean;

    /**
     * Padding left and right on stage (can see neighbours).
     */
    @Prop({ type: Number, default: 0 }) stagePadding!: number;

    /**
     * Set non grid content. Try using width style on divs.
     */
    @Prop({ type: Boolean, default: false }) autoWidth!: boolean;

    /**
     * Set non grid content. Try using height style on divs.
     */
    @Prop({ type: Boolean, default: false }) autoHeight!: boolean;

    /**
     * Autoplay interval timeout.
     */
    @Prop({ type: Number, default: 5000 }) autoplayTimeout!: number;

    /**
     * Show dots navigation.
     */
    @Prop({ type: Boolean, default: false }) dots!: boolean;

    /**
     * Pause on mouse hover.
     */
    @Prop({ type: Boolean, default: false }) autoplayHoverPause!: boolean;

    /**
     * Object containing responsive options. Can be set to false to remove responsive capabilities.
     * Example : :responsive="{0:{items:1,nav:false},600:{items:3,nav:true}}"
     */
    @Prop({ type: Object }) responsive!: object;
}

export default Props;
